import React from "react";
import { NavLink } from "react-router-dom";
import lcm_album from './image/introduce/lcm_album.png';
import team_album from './image/introduce/team_album_m.png';
import quick_album from './image/introduce/quick_album.png';
import back from "./image/introduce/back.png";
import HeroGallery from './hero_gallery_m';
import short_trek from './image/introduce/short_trek_m.png';

const ServiceCard = ({ title, subTitle, description, image, link, label, reverse = false }) => (
  <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center justify-between gap-6 md:gap-16 my-12 md:my-28 w-full`}>
    
    {/* KHỐI ẢNH: Trên di động sẽ tràn viền, bỏ bớt padding */}
    <div className="w-full md:w-1/2 flex justify-center -mx-4 md:mx-0"> 
      <div className="relative w-full">
        {/* Lớp nền trang trí chỉ hiện trên Desktop để tránh rối mắt di động */}
        <div className="hidden md:block absolute inset-0 bg-sky-100 rounded-[50px] rotate-3 -z-10 opacity-40"></div>
        
        <div className="overflow-hidden md:rounded-[45px] shadow-lg md:shadow-2xl md:border-4 border-white bg-white">
          <img 
            src={image} 
            alt={title} 
            className="w-full h-[350px] md:h-[500px] object-cover" // Tăng chiều cao h-350 trên mobile
          />
        </div>
      </div>
    </div>

    {/* KHỐI CHỮ: Căn giữa trên di động, căn trái trên desktop */}
    <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left px-4 mt-4 md:mt-0">
      <span className="bg-orange-100 text-orange-600 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest mb-3">
        {label}
      </span>
      <h2 className="text-6xl md:text-8xl font-black text-sky-600 leading-[0.8] mb-1">{title}</h2>
      <h3 className="text-5xl md:text-7xl font-black text-slate-800 leading-none mb-4">{subTitle}</h3>
      <p className="text-md md:text-xl text-slate-500 italic font-medium mb-6 leading-relaxed max-w-sm">
        "{description}"
      </p>
      <NavLink to={link} className="w-full md:w-auto">
        <button className="w-full md:w-auto bg-slate-900 text-white px-10 py-4 rounded-2xl font-bold uppercase tracking-widest text-xs">
          Khám phá ngay
        </button>
      </NavLink>
    </div>
  </div>
);

export default function Introduce() {
  return (
    <div className="relative min-h-screen font-sans bg-white overflow-x-hidden"
         style={{ backgroundImage: `url(${back})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}
         >
      
      <div className="absolute inset-0 bg-white/80 backdrop-blur-[1px] z-0"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-0 md:px-12 py-10">
        
        {/* PHẦN HERO: Tăng kích thước tối đa trên di động */}
      <section className="mt-20 md:mt-24 mb-10 px-4 md:px-0"> {/* Thêm px-4 ở đây */}
        <div className="rounded-[30px] md:rounded-[60px] overflow-hidden shadow-xl border-4 md:border-[12px] border-white bg-white">
          <HeroGallery />
        </div>
      </section>

        {/* Thêm padding cho phần nội dung phía dưới để không dính sát mép */}
        <div className="px-5 md:px-0 space-y-20">
          
          <ServiceCard 
            title="LEARN" subTitle="TREK" label="Khởi đầu bản lĩnh"
            description="Quan sát tỉ mỉ, vững chãi từng li"
            image={short_trek} link="/short"
          />
          <ServiceCard 
            title="EASY" subTitle="TREK" label="Phổ biến nhất"
            description="Ngàn thước lên cao, ngàn thước xuống "
            image={team_album} link="/tour"
          />

          <ServiceCard 
            title="QUICK" subTitle="TREK" label="Tour Ngẫu Hứng"
            description="10 phút là có một chuyến đi - Tiết kiệm thời gian, tối đa trải nghiệm."
            image={quick_album} link="/book" reverse
          />

          <ServiceCard 
            title="KEEP" subTitle="GOING" label="Tour 0 đồng"
            description="Nối vòng tay lớn - Hành trình thong dong đến những đỉnh cao"
            image={lcm_album} link="/lcm"
          />
        </div>

        {/* Footer */}
        <footer className="text-center py-20 text-slate-700 font-bold text-[10px] tracking-[0.5em] uppercase">
          Leo Núi Việt Nam — 2026
        </footer>
      </div>
    </div>
  );
}